// extracted by mini-css-extract-plugin
module.exports = {"Languages":"Languages_Languages__39AzO","Icon":"Languages_Icon__2W-fG","LanguagesSelect":"Languages_LanguagesSelect__2-7nD","minimalist":"Languages_minimalist__3svpx"};